import { useTranslation } from "@impero-com/common/utils/i18n";
import { Checkbox } from "antd";

import * as theme from "./TestingActivityArchivedFilterRow.css";
import { TestingActivityArchivedFilters } from "./useTestingActivityArchivedFilter";

interface TestingActivityArchivedFilterRowProps {
    archivedFilters: TestingActivityArchivedFilters;
}

export function TestingActivityArchivedFilterRow({
    archivedFilters,
}: TestingActivityArchivedFilterRowProps) {
    const { active, archived, setActive, setArchived } = archivedFilters;
    const { t } = useTranslation();

    return (
        <div className={theme.row}>
            <Checkbox
                checked={active}
                onChange={(e) => setActive(e.target.checked)}
            >
                {t("TestingActivities_ActiveFilterCheckbox")}
            </Checkbox>
            <Checkbox
                checked={archived}
                onChange={(e) => setArchived(e.target.checked)}
            >
                {t("TestingActivities_ArchivedFilterCheckbox")}
            </Checkbox>
        </div>
    );
}
